import React,{useEffect} from "react";
import Header from "./header";
import Footer from "./footer";
import { useSelector, useDispatch } from "react-redux";
import {getAnniversary} from "../state/action"
import {Link} from "react-router-dom"
export default function Anniversary(){
  const  anniversary  = useSelector((state) =>state.gemstone.anniversary);
 
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAnniversary());
  }, []);
    return (
        <div>
        <Header/>
        <section className="page-title centred" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1514612497953-05d1e5e171fa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80)'}}>
  <div className="auto-container">
    <div className="content-box">
      <div className="title">
        <h1>Anniversary</h1>
      </div>
    </div>
  </div>
  <p style={{color: 'white'}}>The gift of an anniversary gemstone is reserved for wedding anniversary for ages. It is one of
wedding anniversary traditions. Below are the most common wedding anniversary years and
their gift gemstones.</p>
</section>

<section className="team-section sec-pad">
  <div className="auto-container">
    <div className="row clearfix">
      {anniversary.map((i)=>{
   return (
    <div className="col-lg-4 col-md-6 col-sm-12 team-block">
    <div className="team-block-one wow fadeInUp animated animated" data-wow-delay="00ms" data-wow-duration="1500ms">
      <div className="inner-box">
        <figure className="image-box"> 
          <img style={{width:"900px",height:"300px"}} src={i.image} alt />
         
        </figure>
        <div className="lower-content">
          <h4>{i.name}</h4>
          <span className="designation">{i.year}</span>
        </div>
      </div>
    </div><br></br>
  </div>
   )
      })}
     
      
    </div>
  </div>
</section>



         <Footer/>
        </div>
    )
}
